/**
 * The XMLElement is an abstract base class that can store a
 * particular value and escape XML specific characters.
 *
 * @param {Object} oConfig - Configuration object that contains the value of this XML Element
 * @constructor
 * @abstract
 */
function XMLElement(oConfig) {
	this.value = oConfig && (oConfig.value || typeof oConfig.value === "number") ? oConfig.value : "";
}

/**
 * Escapes the given String value to fulfill the requirements of
 * XML encoded characters. If the String does not contain any
 * character that needs to be encoded, the original String will
 * be returned.
 *
 * This significantly increases the performance because the
 * initial regular expression match is much faster than the
 * String replace function. We assume that only a few Strings
 * need to be encoded.
 *
 * The following characters need to be encoded:
 * < (lower than)
 * > (greater than)
 * " (quotes)
 * & (ampersand)
 *
 * @param {string} sValue - The value that needs to be XML encoded
 * @returns {string} - XML encoded String
 */
XMLElement.prototype.xmlEncode = function(sValue) {
	return typeof sValue === "string" && sValue.match(/[><"&]+/) !== null ? this._replace(sValue) : sValue;
};

/**
 * @see _xmlEncode
 * @param {string} sValue - The string that contains characters that needs to be replaced
 * @returns {string} - XML encoded String
 * @private
 */
XMLElement.prototype._replace = function(sValue) {

	/**
	 * Perform ampersand replacement first to avoid encoding the
	 * control ampersand of other encoded characters.
	 *
	 * i.E. >& should be encoded as &gt;&amp; instead of &amp;gt;&amp;
	 */
	return sValue
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;");
};

module.exports = XMLElement;